import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { DISPOSITION_KEYS, PHONE_NUMBER, DELIVERY_PARTNER } from 'common/constants/SharedConstants';
import { getFullAddressDetails } from 'common/utilities/utils';
import ModalComponent from 'molecules/Modal';

const getNeedHelpLazyView = params => {
  return <LazyLoaderWrapper {...params} testId='need_help_view' importPath='NEED_HELP_VIEW'></LazyLoaderWrapper>;
};

export const getDispositionTitle = service => {
  switch (service?.toUpperCase()) {
    case DISPOSITION_KEYS.DELIVERY:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERY_TITLE);
    case DISPOSITION_KEYS.PICKUP:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.PICKUP_TITLE);
    // no default
  }
  return '';
};

export const getNeedHelpView = params => {
  return params?.isModalView ? getNeedHelpModalView(params) : getNeedHelpLazyView(params);
};

export const getNeedHelpModalView = params => {
  const { service, handleClose, isOpen } = params;

  const receiptModalProps = {
    role: 'dialog',
    modalTitleId: 'need-help-modal',
    show: true,
    classNames: 'need-help-modal',
    showCloseBtn: true,
    closeButtonHandler: handleClose,
    modalTitle: getDispositionTitle(service),
    showBackBtn: false,
    closeDataTestId: 'close-need-help-modal',
    id: 'NeedHelpModal',
    autoFocus: true,
  };

  return isOpen && <ModalComponent {...receiptModalProps}>{getNeedHelpLazyView(params)}</ModalComponent>;
};

export const getContactNumber = params => {
  const { service, contentData, store, deliveryPartner } = params;
  const { helpSectionCallDetails } = contentData;

  switch (service?.toUpperCase()) {
    case DISPOSITION_KEYS.PICKUP:
      return (
        store?.phoneNumber ||
        store?.contacts.find(contactNumber => {
          return contactNumber.key === PHONE_NUMBER;
        })?.value
      );
    case DISPOSITION_KEYS.DELIVERY:
    default:
      return deliveryPartnerContactNo(deliveryPartner, helpSectionCallDetails);
  }
};

export const getMessageDetails = (event, params) => {
  event.preventDefault();
  const { contentData, history, handleClose } = params;
  const { helpSectionContactDetails } = contentData;
  handleClose();
  history.push({ pathname: helpSectionContactDetails?.url }) ||
    history.push({ pathname: helpSectionContactDetails?.internalURL });
};

export const deliveryPartnerContactNo = (deliveryPartner, helpSectionCallDetails) => {
  switch (deliveryPartner?.toLowerCase()) {
    case DELIVERY_PARTNER.SKEDADEL:
      return `${helpSectionCallDetails?.skedadelContactNo}`;
    case DELIVERY_PARTNER.UBERDIRECT:
      return `${helpSectionCallDetails?.uberDirectContactNo}`;
    case DELIVERY_PARTNER.KFC_GENERIC_MSG:
      return `${helpSectionCallDetails?.kfcGenericContactNo}`;
    default:
      return `${helpSectionCallDetails?.contactNo}`;
  }
};

export const getContactNowBtnText = params => {
  const { service, contentData, deliveryPartner } = params;
  const { helpSectionCallDetails } = contentData;

  switch (service?.toUpperCase()) {
    case DISPOSITION_KEYS.PICKUP:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.CALL_KFC_STORE);
    case DISPOSITION_KEYS.CATERING:
      return translateWithI18Next(TRANSLATE_MAPPING_KEY?.CALL_KFC_STORE);
    case DISPOSITION_KEYS.DELIVERY:
    default:
      return `${helpSectionCallDetails?.buttonText} ${deliveryPartnerContactNo(
        deliveryPartner,
        helpSectionCallDetails,
      )}`;
  }
};

const getStoreName = params => (params && Array.isArray(params) ? params?.[0]?.value : params);

export const deliveryPartnerfn = (deliveryPartner, helpSectionCallDetails) => {
  const getTemplate = (text1, text2, text3) => {
    return (
      <span>
        {helpSectionCallDetails?.[text1]} <span className='bold-text'>{helpSectionCallDetails?.[text2]} </span>
        {helpSectionCallDetails?.[text3]}
      </span>
    );
  };
  switch (deliveryPartner?.toLowerCase()) {
    case DELIVERY_PARTNER.SKEDADEL:
      return getTemplate('skededal1', 'skededal2', 'skededal3');
    case DELIVERY_PARTNER.UBERDIRECT:
      return getTemplate('uberDirect1', 'uberDirect2', 'uberDirect3');
    case DELIVERY_PARTNER.KFC_GENERIC_MSG:
      return getTemplate('kfcGenericMsg1', 'kfcGenericMsg2', 'kfcGenericMsg3');
    default:
      return getTemplate('val1', 'val2', 'val3');
  }
};

export const getHelpSectionCallDetails = params => {
  const { service, contentData, store, deliveryPartner } = params;
  const { helpSectionCallDetails, callsupportcontent = [] } = contentData;
  switch (service?.toUpperCase()) {
    case DISPOSITION_KEYS.PICKUP:
      return (
        <div>
          {!callsupportcontent.length && (
            <>
              <span className='bold-text'>{getStoreName(store?.name)}</span>
              <br />
              {getFullAddressDetails(store?.address || store?.addresses?.[0]?.address)}
            </>
          )}
          {callsupportcontent.length && <span>{callsupportcontent[0]?.fields?.description}</span>}
        </div>
      );
    case DISPOSITION_KEYS.CATERING:
      return (
        <div>
          <span className='bold-text'>{getStoreName(store?.name)}</span>
          <br />
          {getFullAddressDetails(store?.address || store?.addresses?.[0]?.address)}
        </div>
      );
    case DISPOSITION_KEYS.DELIVERY:
    default:
      return deliveryPartnerfn(deliveryPartner, helpSectionCallDetails);
  }
};
